module.exports = __webpack_public_path__ + "static/img/irole.3192b9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/role3/swbnzk/irole.png
// module id = 05i9
// module chunks = 7